import { forwardRef } from "react"
import * as Switch from "@radix-ui/react-switch"
import { cn } from "../../../lib/utils"

/**
 * AppSwitch — Radix Switch primitive styled with Tailwind.
 * Rebuilt from scratch (migration 2026-Q1). SCSS deleted.
 *
 * Props: { id, label, checked, onCheckedChange, disabled }
 * Visual: 42×24px track, 18×18px thumb, translateX(3px→21px), green when checked.
 * Touch: wrapper provides min 44×44px tap target.
 */
const AppSwitch = forwardRef(function AppSwitch(
  { id, label, checked, onCheckedChange, disabled = false, ...rest },
  ref,
) {
  return (
    <div className="flex items-center gap-[10px]">
      {/* 44×44 touch-target wrapper — visually shows 42×24 track */}
      <div className="flex min-h-[44px] min-w-[44px] items-center justify-center">
        <Switch.Root
          ref={ref}
          id={id}
          checked={checked}
          onCheckedChange={onCheckedChange}
          disabled={disabled}
          {...rest}
          className={cn(
            // Track: 42×24px pill
            "relative h-[24px] w-[42px] shrink-0 cursor-pointer rounded-full border-0 p-0",
            "outline-none transition-colors duration-150",
            // Unchecked color (gray in both modes)
            "bg-[var(--gray-6)]",
            // Checked: primary green (bright in both modes)
            "data-[state=checked]:bg-[var(--brand-green,#00875A)]",
            // Disabled: reduced opacity but still visible
            "data-[disabled]:cursor-not-allowed data-[disabled]:opacity-60",
            // Focus ring
            "focus-visible:ring-2 focus-visible:ring-[var(--brand-green,#00875A)] focus-visible:ring-offset-1",
          )}
        >
          <Switch.Thumb
            className={cn(
              // 18×18 white circle, absolutely positioned within track
              "block h-[18px] w-[18px] rounded-full bg-white",
              "shadow-[0_1px_3px_rgba(0,0,0,0.2)]",
              // Unchecked: 3px from left edge
              "translate-x-[3px] transition-transform duration-150",
              // Checked: 21px from left edge
              "data-[state=checked]:translate-x-[21px]",
            )}
          />
        </Switch.Root>
      </div>
      {label && (
        <label
          htmlFor={id}
          className="cursor-pointer text-[13px] text-[var(--text-body,#334155)]"
        >
          {label}
        </label>
      )}
    </div>
  )
})

export default AppSwitch
